import React, { useMemo } from 'react';
import c from 'classnames';
import Immutable from 'immutable';

import {
  WysiwygField,
} from '@uncinc/uncinc-react-kitchen-sink';

import Video from '../../../components/Video';

import './style.scss';

const ParagraphVideo = ({ entity, className }) => {
  const classNames = c('Paragraph', 'ParagraphVideo', className);

  const title = entity.getIn(['field_title', 0, 'value'], '');
  const text = entity.getIn(['field_text', 0, 'processed'], '');
  const mediaItem = entity.getIn(['field_media_item', 0], Immutable.Map());

  const MEDIA_ITEM_BUNDLE_VIDEO = 'video';
  const MEDIA_ITEM_BUNDLE_REMOTE_VIDEO = 'remote_video';

  const url = useMemo(() => {
    switch (mediaItem.get('bundle', '')) {
      case MEDIA_ITEM_BUNDLE_VIDEO:
        return mediaItem.get('source');

      case MEDIA_ITEM_BUNDLE_REMOTE_VIDEO:
        return mediaItem.get('embed');

      default:
        return '';
    }
  }, [mediaItem]);

  return (
    <article className={classNames}>
      {title.length > 0 && (
        <div className="ParagraphVideo__title">
          <h2>{title}</h2>
        </div>
      )}

      {text.length > 0 && (
        <div className="ParagraphVideo__text">
          <WysiwygField
            property="schema:text"
            html={text}
          />
        </div>
      )}

      {url.length > 0 && (
        <Video url={url} />
      )}
    </article>
  );
};

export default ParagraphVideo;
